// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnrollmentV2CopayProgramTypeName } from './enrollmentV2CopayProgramTypeName.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ChangeProgramTypeRequestModel {
    'enrollmentId': number;
    'newProgramType': EnrollmentV2CopayProgramTypeName;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ChangeProgramTypeRequestModel>> = [
        {
            "name":     "enrollmentId",
            "baseName": "enrollmentId",
            "type":     "number"
        },
        {
            "name":     "newProgramType",
            "baseName": "newProgramType",
            "type":     "EnrollmentV2CopayProgramTypeName"
        },
    ];

    static getAttributeTypeMap() {
        return ChangeProgramTypeRequestModel.attributeTypeMap;
    }
}
